import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  logo: {
    flexGrow: 100,
    marginTop: 5,
    textAlign: 'center',
  },
  toolbar: {},
  lowertoolbar: {
    minHeight: 30,
    backgroundColor: theme.palette.constrastGreyDark.main,
    borderTop: '1px solid #e0e0d1',
  },
  icon: {
    cursor: 'pointer',
  },
  homeIcon: {
    color: '#ffffff',
    fontSize: 45,
  },
  divider: {},
}));
